import Axios from "axios";
import { SET_SHIFT_LIST, UNSET_SHIFT_LIST } from "@/store/mutation-types";
import { saveUpdateShift, getShiftList } from "@/store/api";
// initial state
const state = {
    getShiftList: [],
};

const getters = {
    getShiftList(state) {
        return state.getShiftList;
    },
};

const mutations = {
    [SET_SHIFT_LIST](state, data) {
        state.getShiftList = data;
    },
    [UNSET_SHIFT_LIST](state) {
        state.getShiftList = [];
    },
};

const actions = {
    saveUpdateShift({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateShift, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getShiftList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getShiftList, data)
                .then(function (response) {
                    commit("SET_SHIFT_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_SHIFT_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
